(function () {
  'use strict';

  if (window.KaosMachineFinderLoaded) return;
  window.KaosMachineFinderLoaded = true;

  var storageKey = 'kaosSelectedMachineV1';
  var exactFitmentParam = 'filter.p.m.kaos_filter.fitment_key';
  var vehicleFilterParams = [
    exactFitmentParam,
    'filter.p.m.kaos_filter.year',
    'filter.p.m.kaos_filter.make',
    'filter.p.m.kaos_filter.model',
    'filter.p.m.kaos_filter.submodel',
    'filter.p.m.kaos_filter.drive',
    'filter.p.m.kaos_filter.vehicle_type'
  ];
  var indexPromise;

  function syncPageFitmentState() {
    var params = new URLSearchParams(window.location.search);
    document.documentElement.classList.toggle('kaos-exact-fitment-active', params.has(exactFitmentParam));
  }

  function clearMachine() {
    try {
      window.localStorage.removeItem(storageKey);
    } catch (error) {
      // Private browsing can disable storage. URL cleanup still works.
    }
    var url = new URL(window.location.href);
    vehicleFilterParams.forEach(function (param) { url.searchParams.delete(param); });
    url.searchParams.delete('page');
    window.location.assign(url.pathname + url.search + url.hash);
  }

  syncPageFitmentState();

  function naturalSort(a, b) {
    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
  }

  function readSavedMachine() {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey) || 'null');
    } catch (error) {
      return null;
    }
  }

  function saveMachine(machine) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(machine));
    } catch (error) {
      // Private browsing can disable storage. The finder still works for this visit.
    }
  }

  function loadIndex(url) {
    if (!indexPromise) {
      indexPromise = window.fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Machine index request failed');
        return response.json();
      }).then(function (index) {
        if (!index || !index.departments || !Array.isArray(index.rules)) {
          throw new Error('Machine index is invalid');
        }
        return index;
      });
    }
    return indexPromise;
  }

  function setOptions(select, values, placeholder) {
    select.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);
    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
    select.disabled = values.length === 0;
  }

  function initFinder(root) {
    if (root.dataset.kaosInitialized === 'true') return;
    root.dataset.kaosInitialized = 'true';

    var form = root.querySelector('[data-kaos-machine-form]');
    var departmentSelect = root.querySelector('[data-kaos-department]');
    var yearSelect = root.querySelector('[data-kaos-year]');
    var makeSelect = root.querySelector('[data-kaos-make]');
    var modelInput = root.querySelector('[data-kaos-model]');
    var modelOptions = root.querySelector('[data-kaos-model-options]');
    var submit = root.querySelector('[data-kaos-machine-form] button[type="submit"]');
    var status = root.querySelector('[data-kaos-machine-status]');
    var savedPanel = root.querySelector('[data-kaos-saved-machine]');
    var savedLabel = root.querySelector('[data-kaos-saved-machine-label]');
    var savedLink = root.querySelector('[data-kaos-saved-machine-link]');
    var changeButton = root.querySelector('[data-kaos-change-machine]');
    var clearButton = root.querySelector('[data-kaos-clear-machine]');
    var index;
    var validModels = [];

    function setModelOptions(values) {
      validModels = values.slice().sort(naturalSort);
      modelOptions.innerHTML = '';
      validModels.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        modelOptions.appendChild(option);
      });
      modelInput.value = '';
      modelInput.disabled = validModels.length === 0;
      modelInput.placeholder = validModels.length ? 'Start typing model' : 'Choose make first';
    }

    function exactModelSelected() {
      return validModels.indexOf(modelInput.value) !== -1;
    }

    function selectedDepartment() {
      return index && index.departments[departmentSelect.value];
    }

    function updateSubmit() {
      submit.disabled = !(departmentSelect.value && yearSelect.value && makeSelect.value && exactModelSelected());
    }

    function showForm() {
      savedPanel.hidden = true;
      form.hidden = false;
    }

    function showSaved(machine) {
      if (!machine || !machine.url || !machine.label) return;
      savedLabel.textContent = machine.label;
      savedLink.href = machine.url;
      savedPanel.hidden = false;
      if (root.dataset.mode === 'compact') form.hidden = true;
    }

    departmentSelect.addEventListener('change', function () {
      var department = selectedDepartment();
      var years = department ? Object.keys(department.machines || {}).sort(function (a, b) { return Number(b) - Number(a); }) : [];
      setOptions(yearSelect, years, 'Choose year');
      setOptions(makeSelect, [], 'Choose make');
      setModelOptions([]);
      updateSubmit();
    });

    yearSelect.addEventListener('change', function () {
      var department = selectedDepartment();
      var yearData = department && department.machines ? department.machines[yearSelect.value] : null;
      setOptions(makeSelect, yearData ? Object.keys(yearData).sort(naturalSort) : [], 'Choose make');
      setModelOptions([]);
      updateSubmit();
    });

    makeSelect.addEventListener('change', function () {
      var department = selectedDepartment();
      var yearData = department && department.machines ? department.machines[yearSelect.value] : null;
      var makeData = yearData ? yearData[makeSelect.value] : null;
      setModelOptions(makeData ? Object.keys(makeData) : []);
      updateSubmit();
    });

    modelInput.addEventListener('input', updateSubmit);
    modelInput.addEventListener('change', updateSubmit);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var department = selectedDepartment();
      var ruleIds = department && department.machines[yearSelect.value] &&
        department.machines[yearSelect.value][makeSelect.value] &&
        department.machines[yearSelect.value][makeSelect.value][modelInput.value];
      if (!ruleIds || !ruleIds.length) {
        status.textContent = 'Choose a model from the suggested matches, or shop by category.';
        return;
      }

      var destination = (department.make_collections || {})[makeSelect.value] || department.default_collection || '/collections/all';
      var url = new URL(destination, window.location.origin);
      ruleIds.forEach(function (ruleId) {
        var value = index.rules[ruleId];
        if (value) url.searchParams.append(index.filter_param, value);
      });
      var label = [yearSelect.value, makeSelect.value, modelInput.value].join(' ');
      var machine = {
        department: departmentSelect.value,
        year: yearSelect.value,
        make: makeSelect.value,
        model: modelInput.value,
        label: label,
        url: url.pathname + url.search
      };
      saveMachine(machine);
      status.textContent = 'Loading exact-fit parts for ' + label + '…';
      window.location.assign(machine.url);
    });

    changeButton.addEventListener('click', showForm);
    clearButton.addEventListener('click', clearMachine);

    status.textContent = 'Loading machine data…';
    loadIndex(root.dataset.indexUrl).then(function (loadedIndex) {
      index = loadedIndex;
      var departments = Object.keys(index.departments).sort(naturalSort);
      setOptions(departmentSelect, departments, 'Choose application');
      if (departments.length === 1) {
        departmentSelect.value = departments[0];
        departmentSelect.dispatchEvent(new Event('change'));
      }
      status.textContent = '';
      showSaved(readSavedMachine());
    }).catch(function () {
      status.textContent = 'The machine finder is being updated. Please shop from the menu for now.';
      form.querySelectorAll('select,button').forEach(function (control) { control.disabled = true; });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-kaos-machine-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
